import IntegrationsForm from "./IntegrationsForm";

export default IntegrationsForm